import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=16e28cb4&scoped=true&lang=pug"
import script from "./JsonViewer.vue?vue&type=script&lang=js"
export * from "./JsonViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e28cb4",
  null
  
)

export default component.exports